<template>
    <div class="main">
      <div class="header">
        <img class="ml20" src="@i/cfa/logo.png">
        <span class="ml20 mr20 fs18">—</span>
        <span class="fs18">精英球员数据库</span>
      </div>
      <div class="content">
        <div class="all_total">
          <div class="total_content mb20">
            <div class="total_item card_shadow mr20">
              <span class="total_tit mr5 fs18" style="width: 128px;line-height: 1.3em;text-align: center;position: relative;top: 15px;"><span style="display: block">注册人数</span><span class="fs12" style="display: block;color: #929292">（2006-2014年龄段）</span></span>
              <span class="total_num DINM fs38" style="min-width: 110px">58478</span>
              <span class="line ml50 mr40"></span>
              <span class="sex_num fs28 DINM mr40" style="min-width: 106px"><img class="mr10" src="@i/cfa/man.png">42826</span>
              <span class="sex_num fs28 DINM" style="min-width: 106px"><img class="mr10" src="@i/cfa/woman.png">15652</span>
            </div>
            <div class="focus total_item card_shadow">
              <span class="total_tit mr10 fs18" style="color: #945D0D">关注球员</span>
              <span class="total_num DINM fs38" style="color: #945D0D">{{focusPlayer}}</span>
            </div>
          </div>
          <div class="total_content mb20">
            <div class="training total_item card_shadow mr20">
              <p class="fs18"><img class="mr10" style="width: 26px;height: 26px" src="@i/cfa/camp.png">训练营（2024年）</p>
              <p class="fs48 DINM mt30 mb50" style="display: block;text-align: center">5</p>
            </div>
            <div class="training total_item card_shadow">
              <p class="fs18"><img class="mr10" style="width: 26px;height: 26px" src="@i/cfa/training.png">集训（2024年）</p>
              <p class="fs48 DINM mt30 mb50" style="display: block;text-align: center">3</p>
            </div>
          </div>
        </div>
        <div class="year_total mt40">
          <div class="year_tab">
            <span class="fs14 mr30 pb5" v-for="item in Object.keys(fixNum)" :class="{'active': currentYear == item}" @click="changeYear(item)"><b class="fs24 DINB">{{item}}</b>年龄段</span>
          </div>
          <div class="total_content mt20">
            <div class="total_item card_shadow">
              <div class="other_card">
                <span class="total_num DINM fs38 mb24">{{parseInt(currentFixNum.man) + parseInt(currentFixNum.woman)}}</span>
                <span class="total_tit fs18">注册球员</span>
              </div>
              <div class="other_card ml30" style="flex: 1">
                <span class="sex_num fs28 DINM mb24"><img class="mr10" src="@i/cfa/man.png">{{currentFixNum.man}}</span>
                <span class="sex_num fs28 DINM"><img class="mr10" src="@i/cfa/woman.png">{{currentFixNum.woman}}</span>
              </div>
              <span class="line ml40 mr40"></span>
              <div class="other_card">
                <span class="total_num DINM fs38 mb24">{{currentFixNum.sys}}</span>
                <span class="total_tit fs18">入库球员</span>
              </div>
              <span class="line ml40 mr40"></span>
              <div class="other_card">
                <span class="total_num DINM fs38 mb24">{{parseInt(currentFixNum.focusMan) + parseInt(currentFixNum.focusWoman)}}</span>
                <span class="total_tit fs18">关注球员</span>
              </div>
              <div class="other_card ml30" style="flex: 1">
                <span class="sex_num fs28 DINM mb24" style="cursor: pointer" @click="toList('man')"><img class="mr10" src="@i/cfa/man.png">{{currentFixNum.focusMan}}</span>
                <span class="sex_num fs28 DINM" style="cursor: pointer" @click="toList('woman')"><img class="mr10" src="@i/cfa/woman.png">{{currentFixNum.focusWoman}}</span>
              </div>
              <span class="line ml40 mr40"></span>
              <div class="other_card">
                <span class="total_num DINM fs38 mb24" style="cursor: pointer" @click="toList('camp')">{{currentFixNum.camp}}</span>
                <span class="total_tit fs18">训练营</span>
              </div>
              <span class="line ml40 mr40"></span>
              <div class="other_card">
                <span class="total_num DINM fs38 mb24" style="cursor: pointer" @click="toList('training')">{{currentFixNum.training}}</span>
                <span class="total_tit fs18">集训</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    data () {
        return {
          focusPlayer: 0,
          fixNum: {
            // 2006: {
            //   'man': 2844,
            //   'woman': 865,
            //   sys: 0,
            //   focusMan: 0,
            //   focusWoman: 0,
            //   camp: 0,
            //   training: 0,
            // },
            // 2007: {
            //   'man': 4973,
            //   'woman': 1678,
            //   sys: 0,
            //   focusMan: 0,
            //   focusWoman: 0,
            //   camp: 0,
            //   training: 0,
            // },
            2008: {
              'man': 3837,
              'woman': 1287,
              sys: 0,
              focusMan: 0,
              focusWoman: 0,
              camp: 0,
              training: 0,
            },
            2009: {
              'man': 5274,
              'woman': 1900,
              sys: 0,
              focusMan: 0,
              focusWoman: 0,
              camp: 0,
              training: 0,
            },
            2010: {
              'man': 5196,
              'woman': 1957,
              sys: 0,
              focusMan: 0,
              focusWoman: 0,
              camp: 0,
              training: 0,
            },
            2011: {
              'man': 5345,
              'woman': 2130,
              sys: 0,
              focusMan: 0,
              focusWoman: 0,
              camp: 0,
              training: 0,
            },
            2012: {
              'man': 4930,
              'woman': 2115,
              sys: 0,
              focusMan: 0,
              focusWoman: 0,
              camp: 0,
              training: 0,
            },
            // 2013: {
            //   'man': 5035,
            //   'woman': 1909,
            //   sys: 0,
            //   focusMan: 0,
            //   focusWoman: 0,
            //   camp: 0,
            //   training: 0,
            // },
            // 2014: {
            //   'man': 5392,
            //   'woman': 1811,
            //   sys: 0,
            //   focusMan: 0,
            //   focusWoman: 0,
            //   camp: 0,
            //   training: 0,
            // },
          },
          currentYear: 2008,
          currentFixNum: {},
          canClick: true,
        }
    },
    mounted () {
        this.changeYear(this.$sg.ss.get('currentYear') ?this.$sg.ss.get('currentYear'): this.currentYear)
        this.getStatistics()
    },
    methods: {
      changeYear (item) {
        if (!this.canClick) return
        this.canClick = false;
        this.currentYear = item;
        this.currentFixNum = this.fixNum[item];
        this.$sg.ss.set('currentYear', this.currentYear)
        this.getStatistics(this.currentYear);
        setTimeout(()=>{
          this.canClick = true;
        }, 1000)
      },
      allFixNum(type){
        let num = 0;
        if(type == 'all'){
          Object.keys(this.fixNum).forEach(item => {
            num = num + parseInt(this.fixNum[item].man);
            num = num + parseInt(this.fixNum[item].woman);
          })
        } else {
          Object.keys(this.fixNum).forEach(item => {
            num = num + parseInt(this.fixNum[item][type]);
          })
        }
        return num;
      },
      getStatistics(year){
        this.$server.getPlayerStatistics({year}).then(res=>{
          if(res.code == 200){
            if(!year){
              this.focusPlayer = res.data.focus_count;
            } else {
              this.currentFixNum.sys = res.data.player_count;
              this.currentFixNum.focusMan = res.data.man_count;
              this.currentFixNum.focusWoman = res.data.woman_count;
              this.currentFixNum.camp = res.data.teens_camp_count;
              this.currentFixNum.training = res.data.training_count;
            }
          }
        })
      },
      toList(type){
        let path = '/player';

        if(type == 'training'){
          path = '/assemble'
        } else if(type == 'camp'){
          path = '/training-camp/index'
        }

        this.$router.push({
          path,
          query: {
            type,
            year: this.currentYear,
            formPath: 'home',
          }
        })
      },
    }
}
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  height: 100%;
  .header{
    display: flex;
    height: 82px;
    line-height: 82px;
    color: #fff;
    background: url("~@i/cfa/header_bg.png") center center no-repeat;
    background-size: 100% 100%;
    img{
      width: 230px;
      height: 60px;
      position: relative;
      top: 15px;
    }
  }
  .content{
    padding: 20px;
    height: calc(100% - 82px);
    overflow-y: auto;
    box-sizing: border-box;
    background: url("~@i/cfa/bottom_bg.png") bottom center no-repeat;
    background-size: 100% 300px;
    .total_content{
      display: flex;
    }
    .total_item{
      position: relative;
      display: flex;
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 18px;
      padding: 24px;
      border-radius: 6px;
      .line{
        width: 1px;
        height: 30px;
        position: relative;
        top: 10px;
        background-color: #E4E4E4;
      }
      .sex_num{
        img{
          width: 20px;
          height: 20px;
        }
      }
      >p{
        display: flex;
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        height: 26px;
        line-height: 26px;
      }
    }
    .card_shadow{
      background-color: #ffffff;
      box-shadow: 0px 24px 34px 0px #0000000A;
    }
    .total_num{
      display: inline-block;
    }
    .all_total{
      .focus{
        background: url("~@i/cfa/focus.png") center center no-repeat;
        background-size: 100% 100%;
      }
      .training{
        display: block;
        height: auto;
        background-image: url("~@i/cfa/camp_bg.png");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        &:last-child{
          background-image: url("~@i/cfa/training_bg.png");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .year_total{
      .total_item{
        height: auto;
        padding: 34px;
      }
      .year_tab{
        >span{
          display: inline-block;
          color: #c8c8c8;
          cursor: pointer;
          border-bottom: 2px solid transparent;
          &.active{
            color: #326A54;
            border-bottom: 2px solid #326A54;
          }
        }
      }
      .other_card{
        display: inline-block;
        text-align: center;
        min-width: 106px;
        font-size: 18px;
        line-height: 1.3em;
        >span{
          display: block;
        }
      }
      .line{
        display: inline-block;
        height: 100%;
        top: 0;
      }
    }
  }
}
</style>
